import {EventType, EventKind, buildEventCreator, overrideKeys} from 'services/analytics';

export const converter = overrideKeys<DeleteSpendEventPayload>({
  historySize: 'history_size',
  listIndex: 'row_index',
});

export const name = EventKind.DeleteSpend;
export const createEvent = buildEventCreator<EventType.Detailed, DeleteSpendEventPayload>({
  name,
  converter,
});
